import isArray from 'lodash/isArray';
import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';

function getNamespace(path) {
    return path[0] === '/' ? path.substring(1) : path;
}

export default function useTransLoader(path) {
    console.log('use-trans-loader path: ', path);
    const namespaces = isArray(path)
        ? path.map(item => getNamespace(item))
        : getNamespace(path);
    const {t, i18n} = useTranslation(namespaces);

    console.log('use-trans-loader namespaces: ', namespaces);
    console.log('use-trans-loader t: ', t);
    console.log('use-trans-loader i18n: ', i18n);
    useEffect(() => {
        i18n.reloadResources(i18n.language, namespaces);
    }, [i18n, namespaces]);

    return {
        t,
        i18n,
    };
}
